export function TestimonialsSection() {
  return (
    <section id="contact-section" className="py-12 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Formulaire à gauche */}
          <div className="order-1">
            <div className="mb-8 md:mb-12">
              <h2 className="text-3xl md:text-5xl font-serif font-light mb-4 md:mb-8">
                BOOK YOUR DATE
              </h2>
            </div>

            {/* Tally Form Embed */}
            <div className="w-full" style={{ minHeight: '600px' }}>
              <iframe
                src="https://tally.so/embed/gDdWld?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                width="100%"
                height="800"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                title="BOOK YOUR DATE"
                style={{ border: 0 }}
                loading="lazy"
              />
            </div>
          </div>

          {/* Image à droite */}
          <div className="relative h-[400px] md:h-[600px] lg:h-[700px] order-2">
            <img
              src="https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/d82018a541cd03ca72f0aa1debf59ee7.png"
              alt="Elegant couple"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
